import OrderModalComponent from './OrderModalComponent'

export default OrderModalComponent
